import { createSlice } from "@reduxjs/toolkit";

import { fetchLanguages } from "./actions";

export const INITIAL_STATE = [];

export const watchwordsLanguagesSlice = createSlice({
  name: "languages",
  initialState: INITIAL_STATE,
  reducers: {
    resetState: () => INITIAL_STATE,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLanguages.fulfilled, (_, { payload }) =>
      (payload || []).map(({ code: value, name: label }) => ({ label, value }))
    );
  },
});
